import React from "react";

export const BillPaymentSuccessIcon = () => {
  return (
    <>
      <svg
        width="81"
        height="80"
        viewBox="0 0 81 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="40.5"
          cy="40"
          r="40"
          fill="#23A26D"
          fillOpacity="0.12"
          style={{
            fill: "#23A26D",
            fill: "color(display-p3 0.1373 0.6353 0.4275)",
            fillOpacity: 0.12,
          }}
        />
        <path
          d="M40.5 20C29.48 20 20.5 28.98 20.5 40C20.5 51.02 29.48 60 40.5 60C51.52 60 60.5 51.02 60.5 40C60.5 28.98 51.52 20 40.5 20ZM50.06 35.4L38.72 46.74C38.44 47.02 38.06 47.18 37.66 47.18C37.26 47.18 36.88 47.02 36.6 46.74L30.94 41.08C30.36 40.5 30.36 39.54 30.94 38.96C31.52 38.38 32.48 38.38 33.06 38.96L37.66 43.56L47.94 33.28C48.52 32.7 49.48 32.7 50.06 33.28C50.64 33.86 50.64 34.8 50.06 35.4Z"
          fill="#23A26D"
          style={{
            fill: "#23A26D",
            fill: "color(display-p3 0.1373 0.6353 0.4275)",
            fillOpacity: 1,
          }}
        />
      </svg>
    </>
  );
};
